'use strict';

var _ = require('lodash');
function FlightManagementSearchCriteriaFactory(RSQLQueryService, currentSearchCriteria) {
  function SearchCriteria() {
    this.rules = [];
  }
  SearchCriteria.prototype.addCriteria = function (criteria) {
    if (_.isArray(criteria)) {
      this.rules = _.concat(this.rules, criteria);
      return;
    }
    this.rules.push(criteria);
  };
  SearchCriteria.prototype.withFilter = function (filterMethod) {
    if (!_.isFunction(filterMethod)) {
      return;
    }
    _.remove(this.rules, filterMethod);
  };
  SearchCriteria.prototype.withCurrentSearchCriteria = function () {
    this.addCriteria(currentSearchCriteria.getSearchCriteria().rules);
  };
  SearchCriteria.prototype.toRSQL = function () {
    return RSQLQueryService.getRsqlQueryFromSearchCriteriaRules(this.rules);
  };
  SearchCriteria.prototype.clone = function () {
    var clonedCriteria = new SearchCriteria();
    clonedCriteria.addCriteria(this.rules);
    return clonedCriteria;
  };
  SearchCriteria.prototype.clear = function () {
    this.rules = [];
  };
  SearchCriteria.prototype.removeRulesExceptGivenFields = function (fields) {
    this.rules = _.filter(this.rules, function (rule) {
      return _.includes(fields, rule.field);
    });
  };
  SearchCriteria.prototype.removeRulesWithGivenField = function (field) {
    this.rules = _.filter(this.rules, function (rule) {
      return rule.field !== field;
    });
  };
  SearchCriteria.prototype.getRule = function (index) {
    return index < this.rules.length ? this.rules[index] : undefined;
  };
  return SearchCriteria;
}
FlightManagementSearchCriteriaFactory.$inject = ['SearchCriteriaRsqlQueryService', 'CurrentStateCriteriaService'];
module.exports = FlightManagementSearchCriteriaFactory;